import { render, staticRenderFns } from "./page-content.vue?vue&type=template&id=bc6aecb6"
import script from "./page-content.vue?vue&type=script&lang=js"
export * from "./page-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports